<template>
    <calendar
        class="custom-calendar"
        :first-day-of-week="1"
        is-expanded
        trim-weeks
        :masks="{ weekdays: 'WWW' }"
        :attributes="attributes"
    >

        <template v-slot:day-content="attributes">
            <div
                @click="$emit('click', attributes.day)"
                class="d-block overflow-hidden"
                :class="Object.keys(attributes.attributesMap || {}).find(key => attributes.attributesMap[key].highlight.base.color == 'green'
                    || attributes.attributesMap[key].highlight.base.color == 'blue' || attributes.attributesMap[key].highlight.base.color == 'red')
                        ? 'cursor-pointer' : ''"
            >
                <span
                    class="day-label text-sm text-gray-900"
                    :class="Object.keys(attributes.attributesMap || {}).find(key => attributes.attributesMap[key].highlight.base.color !== 'gray') ? 'text-white' : ''"
                >
                   {{ attributes.day.day }}
                </span>

                <div class="h-full flex-grow overflow-y-auto">
                    <div
                        v-for="(attributeMap, i) in attributes.attributesMap"
                        v-bind:key="i"
                        class="align-items-center d-flex flex-column"
                        :class="attributeMap.customData.class"
                    >
                        <div v-if="attributeMap.customData.popover">
                            <p
                                v-if="attributeMap.customData.title && attributeMap.customData.title != ''"
                                class="text-xs p-1 bg-blue text-white text-limit mt-4"
                                :id="`popover-${i}`"
                            >
                                {{ attributeMap.customData.title }}
                            </p>

                            <rkm-popover
                                :target="`popover-${i}`"
                                :triggers="`hover`"
                                :placement="`top`"
                            >
                                {{ attributeMap.customData.popover }}
                            </rkm-popover>
                        </div>

                        <div v-else>
                            <p
                                v-if="attributeMap.customData.title && attributeMap.customData.title == 'icon-search'"
                                class="text-xs p-1 bg-blue text-white text-limit mt-4"
                            >
                                <rkm-icon icon="search" />
                            </p>

                            <p
                                v-else-if="attributeMap.highlight.start.color == 'gray'"
                                class="text-xs p-1 bg-blue text-gray-900 text-limit mt-4"
                            >
                                {{ attributeMap.customData.title }}
                            </p>

                            <p
                                v-else-if="attributeMap.customData.title && attributeMap.customData.title != ''"
                                class="text-xs p-1 bg-blue text-white text-limit mt-4"
                            >
                                {{ attributeMap.customData.title }}
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </template>
    </calendar>
</template>

<script>
import Calendar from 'v-calendar/lib/components/calendar.umd'
import moment from 'moment'

export default {
    components: { Calendar },
    computed: {
        attributes() {

            const attributes = []

            this.items.forEach(item => {

                let dates = null

                if (item.dates.start) {

                    dates = {
                        start: moment(item.dates.start, this.dateFormat).toDate(),
                        end: moment(item.dates.end, this.dateFormat).toDate(),
                    }

                } else {

                    dates = moment(item.dates, this.dateFormat).toDate()
                }

                if (!this.isDateHighlighted(attributes, dates)) {

                    const attribute = {
                        customData: {
                            class: item.class,
                            title: item.title,
                            popover: item.popover
                        },
                        dates: dates,
                        highlight: {
                            color: item.highlight,
                            fillMode: item.fillMode ? item.fillMode : 'solid',
                            contentClass: 'highlight-content-class'
                        },
                        contentStyle: {
                            color: 'text-white'
                        },
                    }

                    attributes.push(attribute)
                }
            })

            return attributes
        }
    },
    data: () => ({
        isHighlight: false
    }),
    methods: {
        isDateHighlighted(attributes, date) {

            return attributes.some(attr => {

                if (attr.dates.start) {

                    if (date.start) {

                        const dtStart = moment(date.start)
                        const dtEnd = moment(date.end)

                        return dtStart.isBetween(moment(attr.dates.start).subtract(1, 'days'), moment(attr.dates.end).add(1, 'days'))
                            || dtEnd.isBetween(moment(attr.dates.start).subtract(1, 'days'), moment(attr.dates.end).add(1, 'days'))
                            || moment(attr.dates.start).isBetween(dtStart.subtract(1, 'days'), dtEnd.add(1, 'days'))
                            || moment(attr.dates.end).isBetween(dtStart.subtract(1, 'days'), dtEnd.add(1, 'days'))
                    }

                    const mDt = moment(date)
                    return mDt.isBetween(moment(attr.dates.start).subtract(1, 'days'), moment(attr.dates.end).add(1, 'days'))
                }

                if (date.start) {

                    const dtStart = moment(date.start).subtract(1, 'days')
                    const dtEnd = moment(date.end).add(1, 'days')

                    return moment(attr.dates).isBetween(dtStart, dtEnd)
                }

                return moment(attr.dates).isSame(moment(date))
            })
        }
    },
    props: {
        dateFormat: { type: String, default: 'DD/MM/YYYY' },
        items: { type: Array, default: () => [] }
    }
}
</script>

<style scoped>
.custom-calendar >>> .vc-header {
    background-color: #f1f5f8;
    padding: 10px 0;
}
.custom-calendar >>> .vc-weeks {
    padding: 0;
}
.custom-calendar >>> .vc-weekday {
    background-color: #f8fafc;
    border-bottom: 1px solid #eaeaea;
    border-top: 1px solid #eaeaea;
    padding: 5px 0;
}

.custom-calendar >>> .vc-container {
    border-radius: 0;
    width: 100%;
}

.custom-calendar >>> .vc-day {
    padding: 0 5px 3px;
    text-align: center;
    height: 80px;
    width: 100%;
    background-color: #fff;
}

.custom-calendar >>> .vc-day:hover {
    background-color: rgba(194, 189, 189, 0.3);
}

.custom-calendar >>> .vc-day:not(.on-right) {
    border-right: 1px solid #ededed;
}

.custom-calendar >>> .vc-day:not(.on-bottom) {
    border-bottom: 1px solid #ededed;
}

.custom-calendar >>> .vc-highlight {
    border-radius: 0px !important;
    height: 100%;
    width: 100%;
}

.text-gray-900 {
    --text-opacity: 1;
    color: #1a202c;
    color: rgba(26,32,44,var(--text-opacity));
}

.text-sm {
    font-size: .875rem;
}

.h-full {
    height: 100%;
}

.flex-grow {
    flex-grow: 1;
}

.overflow-y-auto {
    width: 100%;
    box-sizing: content-box;
}

.overflow-x-auto {
    overflow-x: auto;
}

.text-white {
    --text-opacity: 0.9;
    color: rgb(255, 255, 255);
    color: rgba(255, 255, 255,var(--text-opacity)) !important;
}

.mb-1 {
    margin-bottom: 0.25rem;
}

.mt-0 {
    margin-top: 0;
}
.text-xs {
    font-size: .73rem;
}

.bg-blue {
    --bg-opacity: 0.3;
    background-color: rgb(214, 239, 255);
    background-color: rgba(214, 239, 255,var(--bg-opacity));
    border-radius:4px;
}

.overflow-hidden {
    overflow: hidden;
}

.text-limit {
    max-width: 75px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cursor-pointer {
    cursor: pointer;
}

.d-block {
    display: block;
    height: 100%;
}

.mt-4, .my-4 {
    margin-top: 0.5rem !important;
    width: 100% !important;
    min-width: 100%!important;
}

</style>